
import ScrollParallax from 'vue3-parallax/src/components/ScrollParallax.vue';
import BaseImage from "@/components/BaseImage.vue";
import {defineComponent} from "vue";

export default defineComponent({
  name: "Release",
  components: {BaseImage, ScrollParallax},
  data() {
    return {
      songs: [
        {
          title: "Intuition",
          artist: "technoplanet",
          stage: "Qualifiers",
          version: "Advent of Colour",
          desc: "A burst of fiery creativity, an unbounded expression of a song!\n" +
            "Specifically made to cycle through all types of patterns within 2 minutes, it colours the playfield with prismatic patterns."
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
        {
          title: "",
          artist: "",
          stage: "",
          version: "",
          desc: ""
        },
      ]
    }
  },
  computed: {
    songs_(): Array<{title:string, artist:string, stage:string, version:string}> {
      let a = this.songs;
      for (let i of a){
        i.artist  = i.artist  === "" ? "_".repeat(Math.random() * 20 + 5) : i.artist
        i.title   = i.title   === "" ? "_".repeat(Math.random() * 20 + 5) : i.title
        i.stage   = i.stage   === "" ? "_".repeat(Math.random() * 20 + 5) : i.stage
        i.version = i.version === "" ? "_".repeat(Math.random() * 20 + 5) : i.version
      }
      return a;
    }
  },
  methods: {
    desc() : string {
      let a : string = "";
      for (let i = 0; i < 100; i ++){
        a += "_".repeat(Math.random() * 15 + 1);
        a += " ";
      }
      return a;
    }
  }
});
